<template>
  <base-card>
    <h3 class="tw-text-lg tw-leading-6 tw-font-normal tw-text-gray-900">Change Password</h3>
    <base-form class="tw-mt-4" ref="form" v-model="isFormValid">
      <base-text-field label="Current Password" placeholder="Enter current password" type="password" required v-model="currentPassword" />
      <base-text-field label="New Password" placeholder="Enter new password" type="password" required v-model="newPassword" />
      <base-text-field label="Confirm New Password" placeholder="Confirm new password" type="password" required :rules="rules" v-model="confirmNewPassword" />
    </base-form>
    <inline-error id="password-error" title="Error updating password" :message="errorMessage" class="tw-mb-4" />
    <div class="tw-flex tw-justify-end">
      <base-button class="tw-w-full sm:tw-w-auto" :disabled="!isFormValid" :loading="isLoading" @click="resetPassword">Change Password</base-button>
    </div>
  </base-card>
</template>

<script>
import InlineError from "@/components/InlineError";
import cognito from "@/configuration/cognito";

export default {
  components: {
    InlineError,
  },
  data() {
    return {
      isFormValid: true,
      isLoading: false,
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      errorMessage: "",
      rules: [(value) => value === this.newPassword || "Passwords must match"],
    };
  },
  methods: {
    resetPassword() {
      if (!this.$refs.form.validate()) return;

      this.errorMessage = "";
      this.isLoading = true;

      cognito.changePassword({
        oldPassword: this.currentPassword,
        newPassword: this.newPassword,
        onComplete: () => (this.isLoading = false),
        onSuccess: () => this.handleSuccess(),
        onFailure: (err) => (this.errorMessage = err),
      });
    },
    handleSuccess() {
      this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Password Updated", message: "You password was successfully updated" });
      this.currentPassword = "";
      this.newPassword = "";
      this.confirmNewPassword = "";
      this.errorMessage = "";
    },
  },
};
</script>
